//* Libraries imports
import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion"; 
import styles from "./ErrorMessages.module.scss"; 

interface ErrorMessagesProps {
  messages: string[];
  clearErrors: () => void;
}

export const ErrorMessages: React.FC<ErrorMessagesProps> = ({
  messages,
  clearErrors,
}) => {
  useEffect(() => {
    if (messages.length > 0) {
      const timer = setTimeout(() => {
        clearErrors();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [messages, clearErrors]);

  return (
    <AnimatePresence> 
      {messages.length > 0 && (
        <motion.div
          className={styles.errorOverlay}
          initial={{ opacity: 0, y: -20 }} 
          animate={{ opacity: 1, y: 0 }} 
          exit={{ opacity: 0, y: -20, transition: { duration: 0.3 } }} 
          transition={{ duration: 0.5, type: "spring", stiffness: 100 }} 
          id="error-message-container"
        >
          <div
            className={`${styles.errorAlert} alert alert-danger`}
            role="alert"
            id="error-message-alert"
          >
            <div className={styles.errorHeader}>
              <span className={styles.errorTitle}>Ocorreu um erro</span>
              <button
                type="button"
                className={styles.closeButton} 
                aria-label="Close"
                onClick={clearErrors}
              >
                &times;
              </button>
            </div>
            {messages.map((message, index) => (
              <p
                key={index}
                id={`error-message-${index}`}
                className={styles.errorMessageItem} 
              >
                {message}
              </p>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
